import Headers, { ssoHeaders } from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import { staticImgBaseUrl } from "../../config/apiEndpoints";
import Utility from "../../helpers/utility";
import { OrderTypesCode } from "../../helpers/orderTypesConstants";
import { EVENT_NEW_ADDRESS_ADDED } from "../../helpers/analyticsEvents";
import { keyMapsMutation, keyMapsAction } from "../../helpers/storeKeys";

export default {
  namespaced: true,
  state: {
    currentOrderType: OrderTypesCode.DELIVERY_CODE,
    selectedOrderType: "",
    savedAddresses: [],
    editAddress: {},
    showAddAddressLocationScreen: false,
    showEditAddressLocationScreen: false,
    showMyAddressModal: false,
    userInfo: {},
    selectedSavedAddress: LocalStorageFunc.getSelectedUserAddress(),
    isLoadingWidgetAPI: true,
    staticWidgetData: {},
    apiSuccess: false,
  },
  getters: {
    getRearrangedSavedAddress: (state) => () => {
      // selectedSaved address should be at top of this list
      let selectedSavedAddress = state.selectedSavedAddress;
      let found = false;
      state.savedAddresses.map((address) => {
        if (address.address_id == selectedSavedAddress.address_id) {
          found = true;
        }
      });
      if (!found) {
        return state.savedAddresses;
      }
      let filteredSavedAddresses = state.savedAddresses.filter(
        (address) => address.address_id !== selectedSavedAddress.address_id
      );
      if (selectedSavedAddress && filteredSavedAddresses.length > 0) {
        return [selectedSavedAddress, ...filteredSavedAddresses];
      }
      return state.savedAddresses;
    },
  },
  mutations: {
    loadCurrentOrderType(state, payload) {
      let orderTypeFromSelectedStation =
        LocalStorageFunc.getDeliveryTypeStationData()?.deliveryTypeCode;
      let currentOrderType = LocalStorageFunc.getDeliveryType();
      if (orderTypeFromSelectedStation) {
        state.currentOrderType =
          orderTypeFromSelectedStation == OrderTypesCode.TAKEAWAY_ALTERNATE_CODE
            ? OrderTypesCode.TAKEAWAY_CODE
            : orderTypeFromSelectedStation;
      } else if (currentOrderType) {
        state.currentOrderType =
          currentOrderType == OrderTypesCode.TAKEAWAY_ALTERNATE_CODE
            ? OrderTypesCode.TAKEAWAY_CODE
            : currentOrderType;
      }
      state.selectedOrderType = LocalStorageFunc.getSelectedDeliveryType();
      if (Utility.isCurrentlyAtUrl("/store")) {
        LocalStorageFunc.setDeliveryType(state.currentOrderType);
      }
    },
    updateSavedAddresses(state, payload) {
      state.savedAddresses = [...payload];
      LocalStorageFunc.setUserAddresses(payload);
    },
    updateCurrentOrderType(state, payload) {
      if (payload) {
        let currentOrderType =
          payload == OrderTypesCode.TAKEAWAY_ALTERNATE_CODE
            ? OrderTypesCode.TAKEAWAY_CODE
            : payload;
        state.currentOrderType = currentOrderType;
        LocalStorageFunc.setDeliveryType(currentOrderType);
      }
    },
    updateSelectedOrderType(state, payload) {
      if (payload) {
        let selectedOrderType =
          payload == OrderTypesCode.TAKEAWAY_ALTERNATE_CODE
            ? OrderTypesCode.TAKEAWAY_CODE
            : payload;
        state.selectedOrderType = selectedOrderType;
        LocalStorageFunc.setSelectedDeliveryType(selectedOrderType);
      }
    },
    toggleAddEditAddressLocationScreen(state, payload = true) {
      //console.log("inside toggle add edit");
      if (payload == false) {
        state.showEditAddressLocationScreen = false;
        state.showAddAddressLocationScreen = false;
        return;
      } //@todo uncomment unset
      if (LocalStorageFunc.getAddAddressEnable()) {
        state.showAddAddressLocationScreen = true;
        state.showEditAddressLocationScreen = false;
        //LocalStorageFunc.unsetKey("addAddressEnable");
        state.editAddress = {};
        return;
      }
      if (Object.keys(LocalStorageFunc.getEditAddress()) != 0) {
        //console.log("inside toggle only edit");
        state.showEditAddressLocationScreen = true;
        state.editAddress = Utility.tryJsonParse(
          JSON.stringify(LocalStorageFunc.getEditAddress())
        );
        //LocalStorageFunc.unsetKey("editAddress");
        return;
      }
    },
    deleteSavedAddress(state, payload) {
      state.savedAddresses = state.savedAddresses.filter(
        (address) => address?.address_id != payload
      );
    },
    triggerEditAddressModal(state, payload) {
      state.showEditAddressLocationScreen = payload;
    },
    editSaveAddress(state, payload) {
      let savedAddresses = state.savedAddresses.filter(
        (address) => address?.address_id != payload?.address_id
      );
      savedAddresses.push(payload);
      state.savedAddresses = savedAddresses;
    },
    addSaveAddress(state, payload) {
      let savedAddresses = state.savedAddresses;
      savedAddresses.push(payload);
      state.savedAddresses = savedAddresses;
    },
    updateShowMyAddressModal(state, payload) {
      state.showMyAddressModal = payload;
    },
    updateUserInfo(state, payload) {
      state.userInfo = payload;
    },
    updateSelectedUserAddress(state, payload) {
      LocalStorageFunc.setLocalStorageValue("selectedAddress", payload);
      state.selectedUserAddress = Object.assign({}, payload);
    },
    updateStaticWidgetData(state, payload) {
      state.staticWidgetData = payload?.response || {};
    },
    setIsLoadingStaticWidgetApi(state, payload) {
      state.isLoadingWidgetAPI = payload;
    },
    setIsSuccessStaticWidgetApi(state, payload) {
      state.apiSuccess = payload;
    },
  },
  actions: {
    getSavedAddressesApi({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      //commit("updateSavedAddresses", SavedAddressesData?.data);
      let userData = LocalStorageFunc.getUserData();
      if (userData?.headers?.isLoggedIn) {
        ApiCalls.SAVED_ADDRESSES_API({
          headers: Headers(),
          payload: {
            userId: userData?.headers?.userId,
          },
        })
          .then(function (response) {
            if (response?.data?.data) {
              commit("updateSavedAddresses", response?.data?.data);
            } else {
              commit("updateSavedAddresses", []);
            }
            commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
              root: true,
            });
          })
          .catch(function (error) {
            commit("updateSavedAddresses", []);
            console.log("error address", error);
            commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
              root: true,
            });
          });
      } else {
        // handling for guest user saved addresses on local storage
        let addressList = Utility.tryJsonParse(
          localStorage.NON_LOGGED_IN_SAVED_ADDRESSES,
          []
        );
        if (addressList) {
          commit("updateSavedAddresses", addressList);
        } else {
          commit("updateSavedAddresses", []);
        }
      }
      commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
        root: true,
      });
      //commit("updateSavedAddresses", SavedAddressesData?.data);
    },
    updateAddressApi({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) =>
        ApiCalls.UPDATE_ADDRESS_API({
          headers: Headers(),
          payload: {
            addressId: payload?.address_id,
            saveAddressRequest: payload,
          },
        })
          .then(function (response) {
            if (response?.status == 200) {
              commit("updateSavedAddresses", response?.data?.data);
              let updatedSelectedAddress = response?.data?.data[0];
              commit(
                keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
                updatedSelectedAddress,
                {
                  root: true,
                }
              );
              let pos = {
                lat: updatedSelectedAddress.latitude,
                lng: updatedSelectedAddress.longitude,
              };
              let position = {
                coords: {
                  latitude: pos.lat,
                  longitude: pos.lng,
                },
                homePageAddress: {
                  topAddress: updatedSelectedAddress.customer_address_name,
                  bottomAddress: updatedSelectedAddress.formatted_address,
                },
              };
              commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos, {
                root: true,
              });
              dispatch(keyMapsAction.GEO_CODE_API_COMBO, position, {
                root: true,
              });

              return resolve();
            } else {
              commit(
                keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
                "Error during update profile. Please try again",
                {
                  root: true,
                }
              );
              return reject();
            }
          })
          .catch(function (error) {
            console.log("update addr api error", error);
            return reject();
          })
      );
    },
    addAddressApi({ commit, dispatch }, payload) {
      console.log("payload", payload);
      return new Promise((resolve, reject) =>
        ApiCalls.ADD_ADDRESS_API({
          headers: Headers(),
          payload: {
            mobile: LocalStorageFunc.getUserMobileNo(),
            saveAddressRequest: payload?.saveAddressRequest,
          },
        })
          .then(function (response) {
            if (response?.data?.status == "SUCCESS") {
              EVENT_NEW_ADDRESS_ADDED();
              let selectedAddress = response?.data?.data[0] || {};
              if (selectedAddress?.address_id) {
                commit(
                  keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
                  selectedAddress,
                  {
                    root: true,
                  }
                );
                let pos = {
                  lat: selectedAddress.latitude,
                  lng: selectedAddress.longitude,
                };
                let position = {
                  coords: {
                    latitude: pos.lat,
                    longitude: pos.lng,
                  },
                  homePageAddress: {
                    topAddress: selectedAddress.customer_address_name,
                    bottomAddress: selectedAddress.formatted_address,
                  },
                };
                commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos, {
                  root: true,
                });
                dispatch(keyMapsAction.GEO_CODE_API_COMBO, position, {
                  root: true,
                });
              }
              return resolve();
            } else {
              commit(
                keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
                "Error during update profile. Please try again",
                {
                  root: true,
                }
              );
              return reject();
            }
          })
          .catch(function (error) {
            console.log("add addr api error", error);
            commit(
              keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
              "Error during update profile. Please try again",
              {
                root: true,
              }
            );
            return reject();
          })
      );
    },
    deleteAddressApi({ commit, dispatch }, payload) {
      if (LocalStorageFunc.isLoggedIn()) {
        ApiCalls.DELETE_ADDRESS_API({
          headers: Headers(),
          payload: {
            userId: LocalStorageFunc.getUserId(),
            addressId: payload?.addressId,
          },
        })
          .then(function (response) {
            if (response?.data?.status == "SUCCESS") {
              let selectedAddress = LocalStorageFunc.getSelectedUserAddress();
              if (selectedAddress?.address_id == payload?.addressId) {
                commit(keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS, false, {
                  root: true,
                });
                LocalStorageFunc.setLocalStorageValue(
                  "selectedUserAddress",
                  false
                );
              }
              dispatch("getSavedAddressesApi", payload);
            }
          })
          .catch(function (error) {});
      } else {
      }
    },
    getUserInfoApi({ commit }, payload) {
      let userData = LocalStorageFunc.getUserData();
      ApiCalls.GET_USER_INFO_API({
        headers: Headers(),
        payload: {
          userId: userData?.headers?.userId,
        },
      })
        .then(function (response) {
          commit("updateUserInfo", response?.data);
          LocalStorageFunc.setAddressDetail(response?.data);
        })
        .catch(function (error) {
          // console.log("error get user info", error);
        });
    },
    updateUserInfoApi({ commit, dispatch }, payload) {
      let userData = LocalStorageFunc.getUserData();
      console.log("user data inside updateuserinfo api", userData);
      ApiCalls.UPDATE_USER_INFO_API({
        headers: Headers(),
        payload: {
          userId: userData?.headers?.userId,
          updateUserInfoObject: payload,
        },
      })
        .then(function (response) {
          console.log("update-user", response);
          if (response?.data?.status == "SUCCESS") {
            commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true, {
              root: true,
            });
            commit(keyMapsMutation.UPDATE_ITEM_TOAST_MSG, "Profile Updated.", {
              root: true,
            });
            setTimeout(
              () =>
                commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false, {
                  root: true,
                }),
              3000
            );
            // dispatch("getUserInfoApi", payload);
          }
          // console.log("update-user", response);
          // dispatch("getUserInfoApi", payload);
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true, {
            root: true,
          });
          commit(
            keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
            "Error during update profile. Please try again",
            {
              root: true,
            }
          );
          setTimeout(
            () =>
              commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false, {
                root: true,
              }),
            3000
          );
        });
    },
    staticWidgetApi({ commit, rootGetters, state }, payload) {
      if (!state.apiSuccess) {
        commit("setIsLoadingStaticWidgetApi", true);
        ApiCalls.STATIC_WIDGET_API({
          headers: Headers(),
          payload: payload,
        })
          .then(function (response) {
            if (response?.data) {
              commit("updateStaticWidgetData", {
                response: response?.data,
              });
              commit("setIsSuccessStaticWidgetApi", true);
            }
          })
          .catch(function (error) {
            commit("setIsSuccessStaticWidgetApi", false);
          })
          .finally(function () {
            commit("setIsLoadingStaticWidgetApi", false);
          });
      }
    },
  },
};
